
import {
  apiGet,
  apiPut,
  apiDelete,
  apiPost,
} from "../../../utils";

export const getAdministrationDetailsAPI = (data) => {
  return apiGet("/api/administration", data);
};  

export const addAdministrationDetailsAPI = (data) => {
  return apiPost("/api/administration", data);
};

export const updateAdministrationDetailsAPI = (params, data) => {
  return apiPut(`/api/administration/${params.id}`, data);
};

export const deleteAdministrationDetailsAPI = (id) => {
  return apiDelete(`/api/administration/${id}`);
};